import React, { Component } from 'react';
import Power_on from '../../../../../Images/Daikin_Images/icon/power-green.png';
import Power_off from '../../../../../Images/Daikin_Images/icon/power-gray.png';
import { isEmpty } from '../../../../Common/Common';

export default class Power_On_Off extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let img_width = this.props.img_width != null ? this.props.img_width : 20;
		let status_gradient = 'unset';
		if (!isEmpty(this.props.point_info)) {
			if (this.props.point_info.stat == 'true') status_gradient = 'radial-gradient(circle, rgb(126 255 107) 0%, rgba(255,255,255,1) 100%)'
		}

		return (
			<div id='Power_On_Off' style={this.props.style}>
				<div style={{ width: img_width, height: img_width, marginRight: 'auto', marginLeft: 'auto' }}>
					<img src={this.props.on_off == 'on' ? Power_on : Power_off} style={{ width: img_width, }} />
				</div>
			</div>
		)
	}
}